<template>
  <div>
    <p class="ma-3 grey--text">
      The list of publications listed in this and all previous proposals of the same Main Author.
    </p>
    <b-table :fields="fields"
             :items="publications"
             :responsive="true"
             head-variant="light"
             hover
             show-empty
             striped>
      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: 0, currentPage: 1}"/>
      </template>
      <template v-slot:cell(title)="row">
        <span v-if="row.item.title.publication_data">
          {{ row.item.title.publication_data }}, DOI: {{ row.item.title.publication_doi }}
        </span>
        <span v-else>{{ row.item.title }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
  import { ordinalNumber } from '@/helpers/commonTableColumns';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';

  export default {
    name: 'PublicationsListReadonly',
    components: { BaseColumnOrdinalNumber },
    props: {
      proposalState: {
        type: String,
        default: 'submitted',
      },
      userId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        documents: [],
        publications: [],
        fields: [
          ordinalNumber,
          {
            key: 'title',
            label: 'Title',
          },
        ],
      };
    },
    methods: {
      loadData() {
        this.axios.get(`documents/all-infrastructures/${this.proposalState}/${this.userId}`)
          .then((response) => {
            this.prepareDocuments(response.data.documents);
          });
      },
      prepareDocuments(documents) {
        this.publications = documents.reverse().reduce((acc, el) => {
          const rawPublications = el.general?.publications;
          if (Array.isArray(rawPublications)) {
            rawPublications.forEach((publication) => {
              if (publication && !acc.includes(publication)) {
                acc.push(publication);
              }
            });
          } else if (typeof rawPublications === 'string') {
            if (rawPublications && !acc.includes(rawPublications)) {
              acc.push(rawPublications);
            }
          }
          return acc;
        }, []);

        this.publications = this.publications.map((publication) => ({ title: publication }));
      },

    },
    async created() {
      await this.loadData();
    },
  };
</script>

<style scoped>
  /* Modifying bootstrap class to delete ugly bottom white bar */
  .table-responsive {
    margin-bottom: 0;
  }
</style>
